import { registerTile } from '../registry';
import { dateTile } from './date';
import { welcomeTile } from './welcome';

registerTile(welcomeTile);
registerTile(dateTile);
